import type { SxProp } from 'src/types/mui';

export const cardStyles =
  (isSelected: boolean): SxProp =>
  theme => ({
    background: isSelected ? theme.palette.slate?.[50] : '#fff',
    borderRadius: '0',
    maxWidth: 'auto',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.divider}`,
    cursor: isSelected ? 'auto' : 'pointer',
    overflow: 'visible',
  });

export const consumerBtnStyles: SxProp = {
  textTransform: 'none',
  paddingY: '2px',
  paddingX: '2px',
  fontSize: '13px',
};
